module.exports = __webpack_public_path__ + "static/media/sklotom.3689edb0.wav";